import './assets/styles/main.css';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import { shopifyToShoplineXlsxConverter } from '@components/ShopifyToShoplineXlsxConverter.js';

Alpine.plugin(collapse);
Alpine.data('shopifyToShoplineXlsxConverter', shopifyToShoplineXlsxConverter);
window.Alpine = Alpine;
Alpine.start();
